// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.users-page {
  /* container spacing already handled by CContainer's py-4 */
}

.users-page-loading {
  min-height: 200px;
}

.user-role-select {
  width: 110px;
}

/* CoreUI wraps a \`responsive\` CTable in \`.table-responsive\` — give it the
   same card treatment (border, radius, shadow) as the rest of the app so
   the table doesn't sit "bare" on the page background. */
.users-page .table-responsive {
  background: var(--card-bg);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  box-shadow: 0 1px 3px var(--shadow);
  padding: 4px;
  overflow-x: auto;
}

.users-page .table {
  margin: 0;
  color: var(--text-primary);
}

.users-page .table thead th {
  background-color: var(--table-header-bg);
  color: var(--table-header-text);
  font-weight: 700;
  border-bottom: none;
}

.users-page .table td,
.users-page .table th {
  vertical-align: middle;
  border-color: var(--border);
}
`, "",{"version":3,"sources":["webpack://./src/pages/UsersManagementPage.css"],"names":[],"mappings":"AAAA;EACE,2DAA2D;AAC7D;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;;yDAEyD;AACzD;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,mCAAmC;EACnC,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,wCAAwC;EACxC,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,sBAAsB;EACtB,2BAA2B;AAC7B","sourcesContent":[".users-page {\n  /* container spacing already handled by CContainer's py-4 */\n}\n\n.users-page-loading {\n  min-height: 200px;\n}\n\n.user-role-select {\n  width: 110px;\n}\n\n/* CoreUI wraps a `responsive` CTable in `.table-responsive` — give it the\n   same card treatment (border, radius, shadow) as the rest of the app so\n   the table doesn't sit \"bare\" on the page background. */\n.users-page .table-responsive {\n  background: var(--card-bg);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  box-shadow: 0 1px 3px var(--shadow);\n  padding: 4px;\n  overflow-x: auto;\n}\n\n.users-page .table {\n  margin: 0;\n  color: var(--text-primary);\n}\n\n.users-page .table thead th {\n  background-color: var(--table-header-bg);\n  color: var(--table-header-text);\n  font-weight: 700;\n  border-bottom: none;\n}\n\n.users-page .table td,\n.users-page .table th {\n  vertical-align: middle;\n  border-color: var(--border);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
